export default {
      id: "fund-reallocation-tipbox-icon-usage",
      viewBox: "0 0 91 81",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#fund-reallocation-tipbox-icon",
      toString: function () {
        return this.url;
      }
    }